import { Link, Text, OrderedList, ListItem } from '@chakra-ui/react';

export const h1 = ({ children }) => <Text fontWeight="bold">{children}</Text>;

export const h2 = ({ children }) => <Text>{children}</Text>;

export const h3 = ({ children }) => <Text>{children}</Text>;

// NOTE: small hack. Convert ul to ol here, since there's no obvious way to get markdown-toc to generate ordered list items.
export const ul = ({ children }) => (
  <OrderedList m={0} listStyleType="none">
    {children}
  </OrderedList>
);

export const li = ({ children }) => (
  <ListItem
    fontWeight="bold"
    color="gray.600"
    sx={{
      '&': {
        borderBottomColor: 'gray.400',
        borderBottomStyle: 'solid',
        borderBottomWidth: '2px',
      },
      '&:last-of-type': {
        borderBottomWidth: '0px',
      },
      'a + ul > li:first-of-type, a + ol > li:first-of-type': {
        borderTopColor: 'gray.400',
        borderTopStyle: 'solid',
        borderTopWidth: '2px',
      },
    }}
  >
    {children}
  </ListItem>
);

export const a = ({ children, href }: any) => {
  return (
    <Link
      display="block"
      color="#2F7FDA"
      href={href}
      py={4}
      _hover={{
        textDecoration: 'none',
      }}
      sx={{
        '&:before': {
          color: 'gray.800',
          content: '"•"',
          fontSize: 'var(--chakra-fontSizes-xl)',
          marginRight: 'var(--chakra-space-1)',
        },
        'ul ul &, ol ol &': {
          paddingLeft: 'var(--chakra-space-5)',
        },
      }}
    >
      {children}
    </Link>
  );
};
